
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function ProfilePage() {
  const [activeTab, setActiveTab] = useState('about');

  const chef = {
    name: "Chef Gordon",
    title: "Executive Chef & Culinary Artist",
    location: "Cape Town, South Africa",
    experience: "15+ Years",
    rating: 4.9,
    reviewCount: 127,
    image: "https://static.readdy.ai/image/5c2d16bce98820aab16a3b52f2f5cfd8/d6e0050374475abab55ba599156cbec8.jpeg",
    specialties: ["Modern South African Cuisine", "Fine Dining", "Seafood", "Grilled Specialties", "Wine Pairing"],
    about: "Chef Gordon is a passionate culinary artist with over 15 years of experience creating exceptional dining experiences. Trained in classical French techniques and inspired by South African flavors, he brings innovation and creativity to every dish. His commitment to using fresh, locally-sourced ingredients and his attention to detail have earned him recognition as one of Cape Town's premier private chefs.",
    services: [
      {
        title: "Private Dining Experience",
        description: "Intimate dinner parties for 2-12 guests with personalized menus",
        price: "From R2,500 per person"
      },
      {
        title: "Event Catering",
        description: "Full-service catering for special occasions and corporate events",
        price: "From R1,800 per person"
      },
      {
        title: "Cooking Classes",
        description: "Learn professional techniques in hands-on cooking sessions",
        price: "From R1,200 per person"
      },
      {
        title: "Meal Preparation",
        description: "Weekly meal prep service with gourmet, healthy options",
        price: "From R450 per meal"
      }
    ],
    gallery: [
      "https://public.readdy.ai/ai/img_res/1e4a0193d16e430da4b1be510d43dad7.jpg",
      "https://readdy.ai/api/search-image?query=Grilled%20seafood%20platter%20with%20fresh%20lobster%20and%20prawns%2C%20garnished%20with%20herbs%20and%20lemon%2C%20restaurant%20quality%20presentation%2C%20clean%20white%20background&width=400&height=300&seq=gallery2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Elegant%20wine%20pairing%20dinner%20setup%20with%20multiple%20courses%2C%20crystal%20glasses%2C%20fine%20dining%20table%20setting%2C%20warm%20ambient%20lighting&width=400&height=300&seq=gallery3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Professional%20chef%20hands%20preparing%20gourmet%20dish%20in%20modern%20kitchen%2C%20action%20shot%20of%20cooking%20process%2C%20clean%20and%20bright%20kitchen%20environment&width=400&height=300&seq=gallery4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Beautifully%20arranged%20charcuterie%20board%20with%20local%20South%20African%20cheeses%2C%20cured%20meats%2C%20fresh%20fruits%2C%20artisanal%20presentation&width=400&height=300&seq=gallery5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gourmet%20dessert%20with%20artistic%20chocolate%20work%20and%20fresh%20berries%2C%20fine%20dining%20presentation%2C%20elegant%20plating%20on%20dark%20plate&width=400&height=300&seq=gallery6&orientation=landscape"
    ],
    reviews: [
      {
        name: "Sarah Mitchell",
        rating: 5,
        comment: "Chef Gordon created an absolutely magical evening for our anniversary. Every dish was a work of art and the flavors were incredible. Highly recommend!",
        date: "2024-01-15"
      },
      {
        name: "Michael Thompson",
        rating: 5,
        comment: "Outstanding service and exceptional food. Gordon's attention to detail and passion for cooking really shows in every dish. Will definitely book again.",
        date: "2024-01-08"
      },
      {
        name: "Lisa van der Merwe",
        rating: 5,
        comment: "The cooking class was fantastic! Gordon is an excellent teacher and made the experience both educational and fun. Learned so much!",
        date: "2023-12-22"
      }
    ]
  };

  useEffect(() => {
    // Update page title and meta description to match embed_code specifications
    document.title = 'Chef Gershwin Gordon - Private Chef Johannesburg | Modern South African Cuisine';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Private Chef Johannesburg - Gordons Creations | Connect with South Africa\'s finest private chefs for unforgettable culinary experiences. Book professional chefs for intimate dinners, special celebrations, and corporate events in Johannesburg, Cape Town, Durban. Premium private chef services with verified culinary professionals.');
    } else {
      const newMetaDescription = document.createElement('meta');
      newMetaDescription.name = 'description';
      newMetaDescription.content = 'Private Chef Johannesburg - Gordons Creations | Connect with South Africa\'s finest private chefs for unforgettable culinary experiences. Book professional chefs for intimate dinners, special celebrations, and corporate events in Johannesburg, Cape Town, Durban. Premium private chef services with verified culinary professionals.';
      document.head.appendChild(newMetaDescription);
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'private chef, South Africa, Johannesburg, Cape Town, Durban, catering, fine dining, personal chef');
    } else {
      const newMetaKeywords = document.createElement('meta');
      newMetaKeywords.name = 'keywords';
      newMetaKeywords.content = 'private chef, South Africa, Johannesburg, Cape Town, Durban, catering, fine dining, personal chef';
      document.head.appendChild(newMetaKeywords);
    }
    
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "Gershwin Gordon",
      "jobTitle": "Private Chef",
      "description": "Award-winning chef specializing ... Private Chef Johannesburg - Gordons Creations.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/profile/private-chef-johannesburg-gordon`,
      "image": "https://readdy.ai/api/search-image?query=Professional%20South%20African%20chef%20in%20modern%20kitchen%20wearing%20chef%20whites%2C%20confident%20pose%2C%20contemporary%20culinary%20environment%2C%20award-winning%20chef%20portrait%2C%20modern%20restaurant%20setting%2C%20culinary%20expertise&width=400&height=400&seq=gordon-profile&orientation=squarish",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Johannesburg",
        "addressRegion": "Gauteng",
        "addressCountry": "ZA"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "127"
      },
      "knowsAbout": [
        "Modern South African Cuisine",
        "Contemporary Cooking",
        "Private Dining",
        "Gourmet Catering",
        "Fine Dining",
        "Personal Chef Services"
      ],
      "hasOccupation": {
        "@type": "Occupation",
        "name": "Private Chef",
        "occupationLocation": {
          "@type": "City",
          "name": "Johannesburg"
        }
      },
      "brand": {
        "@type": "Brand",
        "name": "Gordons Creations"
      },
      "offers": {
        "@type": "Offer",
        "name": "Private Chef Services",
        "description": "Professional private chef services for intimate dinners, special celebrations, and corporate events",
        "areaServed": [
          {
            "@type": "City",
            "name": "Johannesburg"
          },
          {
            "@type": "City", 
            "name": "Cape Town"
          },
          {
            "@type": "City",
            "name": "Durban"
          }
        ]
      }
    });
    document.head.appendChild(schemaScript);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`ri-star-${i < Math.floor(rating) ? 'fill' : 'line'} text-yellow-400`}
      ></i>
    ));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            {/* Chef Image */}
            <div className="lg:col-span-1">
              <Card className="overflow-hidden">
                <img
                  src={chef.image}
                  alt={`${chef.name} - Professional Chef`}
                  className="w-full h-96 object-cover object-top"
                />
              </Card>
            </div>

            {/* Chef Info */}
            <div className="lg:col-span-2">
              <div className="mb-6">
                <h1 className="text-4xl font-bold text-gray-900 mb-2">{chef.name}</h1>
                <p className="text-xl text-emerald-600 mb-4">{chef.title}</p>
                
                <div className="flex flex-wrap items-center gap-6 mb-6">
                  <div className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-map-pin-line text-gray-600"></i>
                    </div>
                    <span className="text-gray-600">{chef.location}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-time-line text-gray-600"></i>
                    </div>
                    <span className="text-gray-600">{chef.experience}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="flex">{renderStars(chef.rating)}</div>
                    <span className="text-gray-600">{chef.rating} ({chef.reviewCount} reviews)</span>
                  </div>
                </div>

                <div className="mb-8">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Specialties</h3>
                  <div className="flex flex-wrap gap-2">
                    {chef.specialties.map((specialty, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full text-sm"
                      >
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex flex-wrap gap-4">
                  <Button size="lg" className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-calendar-line"></i>
                    </div>
                    Book Now
                  </Button>
                  <Button variant="outline" size="lg" className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-message-line"></i>
                    </div>
                    Send Message
                  </Button>
                  <Button variant="secondary" size="lg" className="flex items-center gap-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-phone-line"></i>
                    </div>
                    Call Chef
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-8">
            {[
              { id: 'about', label: 'About', icon: 'ri-user-line' },
              { id: 'services', label: 'Services', icon: 'ri-service-line' },
              { id: 'gallery', label: 'Gallery', icon: 'ri-image-line' },
              { id: 'reviews', label: 'Reviews', icon: 'ri-star-line' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 py-4 px-2 border-b-2 transition-colors cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-emerald-600 text-emerald-600'
                    : 'border-transparent text-gray-600 hover:text-emerald-600'
                }`}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={tab.icon}></i>
                </div>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* About Tab */}
          {activeTab === 'about' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">About Chef Gordon</h2>
              <Card className="p-8">
                <p className="text-gray-700 leading-relaxed text-lg">{chef.about}</p>
              </Card>
            </div>
          )}

          {/* Services Tab */}
          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Services &amp; Pricing</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {chef.services.map((service, index) => (
                  <Card key={index} className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                    <p className="text-gray-600 mb-4">{service.description}</p>
                    <div className="flex justify-between items-center">
                      <span className="text-lg font-bold text-emerald-600">{service.price}</span>
                      <Button size="sm">Book Service</Button>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          )}

          {/* Gallery Tab */}
          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Culinary Gallery</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {chef.gallery.map((image, index) => (
                  <Card key={index} className="overflow-hidden hover:shadow-xl transition-shadow">
                    <img
                      src={image}
                      alt={`Chef Gordon's culinary creation ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                  </Card>
                ))}
              </div>
            </div>
          )}

          {/* Reviews Tab */}
          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Client Reviews</h2>
              <div className="space-y-6">
                {chef.reviews.map((review, index) => (
                  <Card key={index} className="p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h4 className="font-semibold text-gray-900">{review.name}</h4>
                        <div className="flex items-center gap-2 mt-1">
                          <div className="flex">{renderStars(review.rating)}</div>
                          <span className="text-sm text-gray-500">{review.date}</span>
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{review.comment}</p>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-emerald-600 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ready to Experience Exceptional Cuisine?
          </h2>
          <p className="text-xl text-emerald-100 mb-8">
            Book Chef Gordon for your next special occasion or culinary adventure
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button variant="secondary" size="lg" className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-calendar-line"></i>
              </div>
              Schedule Consultation
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-emerald-600 flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line"></i>
              </div>
              Call Now
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
